"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enhancedContext = exports.pageDefaults = void 0;
const md5_1 = __importDefault(require("md5"));
/**
 * Return a default `options.context.page` object.
 *
 * https://segment.com/docs/spec/page/#properties
 */
function pageDefaults() {
    const viewport = getViewport();
    const userAgent = getUserAgent();
    const screen = getScreen();
    return {
        user_agent_md5: (0, md5_1.default)(userAgent),
        // screen_width: screen.width,
        // screen_height: screen.height,
        // viewport_width: viewport.width,
        // viewport_height: viewport.height,
    };
}
exports.pageDefaults = pageDefaults;
function getUserAgent() {
    return navigator.userAgent;
}
function getViewport() {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
function getScreen() {
    return {
        width: window.screen.width,
        height: window.screen.height,
    };
}
function enrichPageContext(ctx) {
    var _a;
    const event = ctx.event;
    event.context = event.context || {};
    let pageContext = pageDefaults();
    const pageProps = (_a = event.properties) !== null && _a !== void 0 ? _a : {};
    // keys in properties will override the one in page context
    Object.keys(pageContext).forEach((key) => {
        if (pageProps[key]) {
            pageContext[key] = pageProps[key];
        }
    });
    // merge the page properties into our context
    if (event.context.page) {
        pageContext = Object.assign({}, pageContext, event.context.page);
    }
    // and swap it
    event.context = Object.assign({}, event.context, {
        page: pageContext,
    });
    ctx.event = event;
    return ctx;
}
exports.enhancedContext = {
    name: "Enhanced Context",
    version: "0.1.0",
    isLoaded: () => true,
    load: () => Promise.resolve(),
    type: "before",
    page: (ctx) => {
        ctx.event.properties = Object.assign({}, pageDefaults(), ctx.event.properties);
        if (ctx.event.name) {
            ctx.event.properties.name = ctx.event.name;
        }
        return enrichPageContext(ctx);
    },
    alias: enrichPageContext,
    track: enrichPageContext,
    identify: enrichPageContext,
    group: enrichPageContext,
};
